<login-home-navigation></login-home-navigation>

<!-- HERO -->

<section class="about-hero">

    <div class="container">

        <span class="about-badge">
            About Get Your Vendor
        </span>

       <h1>
    India's Manufacturing Supplier Network
</h1>

<p>
    Helping procurement teams discover qualified suppliers and helping manufacturers connect with serious buyers across India.
</p>

    </div>

</section>

<!-- OUR STORY -->

<section class="about-story">

    <div class="container">

        <div class="row align-items-center">

           <div class="col-lg-5">

    <div class="founder-card">

        <img
            src="assets/images/media/sourcing.jpeg"
            alt="Mr. Shekhar Erande"
            class="story-image">

        <div class="founder-info">

            <h4>Mr. Shekhar Erande</h4>

            <p class="designation">
                Founder & Managing Director
            </p>

            <p class="qualification">
                M.S. Mechanical Engineering
            </p>

            <p class="location">
                New York, USA
            </p>

        </div>

    </div>

</div>
            <div class="col-lg-7">

            <span class="section-label">
    OUR STORY
</span>

<h2>
    Building Better
    <br>
    Buyer–Supplier Relationships
</h2>

               <p>
    Get Your Vendor was founded by Mr. Shekhar Erande with a vision to simplify
    the way buyers and manufacturers connect in the industrial ecosystem.
</p>

<p>
    With extensive experience in manufacturing, sourcing and engineering,
    he recognized a common challenge: buyers struggle to identify reliable suppliers,
    while capable manufacturers spend significant time and money on sales and business development.
</p>

<p>
    Get Your Vendor bridges this gap through a digital platform that enables
    supplier discovery, RFQ management and business matchmaking across multiple
    manufacturing categories.
</p>

<p>
    Today, the platform supports thousands of suppliers, procurement professionals
    and manufacturing companies in building long-term business relationships.
</p>

            </div>

        </div>

    </div>

</section>

<!-- MISSION VISION -->

<section class="mission-vision">

    <div class="container">

        <div class="row">

            <div class="col-lg-6">

                <div class="mv-card">

                    <div class="mv-icon">
                        🎯
                    </div>

                    <h3>
                        Our Mission
                    </h3>

                    <p>
                        To simplify supplier discovery and create meaningful business opportunities
                        for buyers and manufacturers across India.
                    </p>

                </div>

            </div>

            <div class="col-lg-6">

                <div class="mv-card">

                    <div class="mv-icon">
                        🚀
                    </div>

                    <h3>
                        Our Vision
                    </h3>

                    <p>
                        To become the most trusted manufacturing sourcing platform connecting
                        businesses globally.
                    </p>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- STATS -->

<section class="trust-section">

    <div class="container">

        <div class="section-header">

            <h2>
                Platform Impact
            </h2>

            <p>
                Trusted by manufacturing companies across India
            </p>

        </div>

        <div class="row">

            <div class="col-lg-3 col-md-6 col-6">

                <div class="trust-card">

                    <h3>16,000+</h3>

                    <p>Verified Suppliers</p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6 col-6">

                <div class="trust-card">

                    <h3>300+</h3>

                    <p>Verified Buyers</p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6 col-6">

                <div class="trust-card">

                    <h3>3,000+</h3>

                    <p>Business Matches</p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6 col-6">

                <div class="trust-card">

                    <h3>100,000+</h3>

                    <p>Platform Visitors</p>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- CORE VALUES -->

<section class="values-section">

    <div class="container">

        <div class="section-header">

            <h2>
                Our Core Values
            </h2>

        </div>

        <div class="row">

            <div class="col-lg-3 col-md-6">

                <div class="value-card">

                    <h4>Trust</h4>

                    <p>
                        Building long-term business relationships through transparency.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="value-card">

                    <h4>Innovation</h4>

                    <p>
                        Using technology to simplify industrial sourcing.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="value-card">

                    <h4>Collaboration</h4>

                    <p>
                        Helping buyers and suppliers grow together.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="value-card">

                    <h4>Growth</h4>

                    <p>
                        Creating opportunities for businesses of every size.
                    </p>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- WHY GYV -->

<section class="why-section">

    <div class="container">

        <div class="section-header">

            <h2>
                Why Companies Choose GYV
            </h2>

        </div>

        <div class="row">

            <div class="col-lg-3 col-md-6">

                <div class="why-card">

                    <h4>Faster Supplier Discovery</h4>

                    <p>
                        Reduce sourcing time and identify suppliers quickly.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="why-card">

                    <h4>Better Visibility</h4>

                    <p>
                        Compare manufacturing capabilities efficiently.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="why-card">

                    <h4>Manufacturing Network</h4>

                    <p>
                        Access suppliers across multiple industrial categories.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="why-card">

                    <h4>Business Growth</h4>

                    <p>
                        Generate opportunities without excessive sales costs.
                    </p>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- CTA -->

<section class="about-cta">

    <div class="container">

        <h2>
            Ready To Grow Your Manufacturing Network?
        </h2>

        <p>
            Join thousands of buyers and suppliers already using Get Your Vendor.
        </p>

        <div class="cta-buttons">

            <a
                routerLink="/buyersbenefits"
                class="cta-primary">

                Find Suppliers

            </a>

            <a
                routerLink="/login/signup"
                class="cta-secondary">

                Register As Supplier

            </a>

        </div>

    </div>

</section>

<login-home-footer></login-home-footer>